import React from "react";
import "./../dashboard.css";
import { LuUsers } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa6";

import { FaLocationDot } from "react-icons/fa6";

const SummaryCards = ({ summary }) => {
  return (
    <div className="row g-3 mb-4">
      <div className="col-xl-3 col-lg-4 col-md-6">
        <div className={`dashboardCard firstcard-bg`}>
          <div className="cardContent">
            <div className="cardLeft">
              <span className="cardTitle">Total Agents</span>
              <h2 className="firstcard-text">{summary?.totalAgents}</h2>
            </div>
            <div className="iconBox firstcard-icon">
              <FaRegUser size={30} />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="col-xl-3 col-lg-4 col-md-6">
        <div className={`dashboardCard green`}>
          <div className="cardPattern"></div>

          <div className="cardContent">
            <div className="cardLeft text-center">
              <span className="cardTitle">Active</span>
              <h2>{summary?.activeAgents}</h2>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="col-xl-2 col-lg-4 col-md-6">
        <div className={`dashboardCard blueGreen`}>
          <div className="cardPattern"></div>

          <div className="cardContent">
            <div className="cardLeft text-center">
              <span className="cardTitle">Inactive</span>
              <h2>{summary?.inactiveAgents}</h2>
            </div>
          </div>
        </div>
      </div> */}

      <div className="col-xl-3 col-lg-4 col-md-6">
        <div className={`dashboardCard secondcard-bg`}>
          <div className="cardContent">
            <div className="cardLeft">
              <span className="cardTitle">Today's Visits</span>
              <h2 className="secondcard-text">{summary?.todayVisits}</h2>
            </div>
            <div className="iconBox secondcard-icon">
              <LuUsers size={30} />
            </div>
          </div>
        </div>
      </div>

      <div className="col-xl-3 col-lg-4 col-md-6">
        <div className={`dashboardCard thirdcard-bg`}>
          <div className="cardPattern"></div>
          <div className="cardContent">
            <div className="cardLeft">
              <span className="cardTitle">Distance</span>
              <h2 className="thirdcard-text">{summary?.todayDistanceKm?.toFixed(2)} <sub>Km</sub></h2>
            </div>
            <div className="iconBox thirdcard-icon">
              <FaLocationDot size={30} />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="col-xl-2 col-lg-4 col-md-6">
        <div className={`dashboardCard green`}>
          <div className="cardPattern"></div>

          <div className="cardContent">
            <div className="cardLeft text-center">
              <span className="cardTitle">Locations</span>
              <h2>{summary?.totalLocationsCaptured}</h2>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SummaryCards;
